export default "__VITE_PUBLIC_ASSET__2aff82db__"